import React, { useEffect, useState } from 'react';
import { Field, Form, Formik, useFormikContext } from 'formik';
import { initCaseFormChange, setFormChanged } from 'app/shared/reducers/case-form-change';
import { Col, FormGroup, Row } from 'reactstrap';
import { Button, Label } from 'edozvola-frontend-lib/dist/ui';
import { FormikPredictiveInput } from 'edozvola-frontend-lib/dist/ui/components/predictive-input/FormikPredictiveInput';
import {
  fetchArrangementAccessCodebook,
  fetchArrangementDrainageCodebook,
  fetchArrangementElectricityCodebook,
} from 'app/edozvola/codebooks/codebooks.service';
import { useParams } from 'react-router-dom';
import { ParticleArrangement } from 'app/edozvola/cases/cases.model';
import { CodebookModel } from 'app/shared/model/shared.model';
import { useDispatch } from 'react-redux';
import { fetchParticleArrangement, saveParticleArrangement } from 'app/edozvola/cases/service/cases.service';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { ERRORS, messages } from 'app/config/constants';
import {updateCaseParticleArrangementMutation} from "app/edozvola/cases/service/cases.queries";

const ParticleArrangementForm = () => {
  const { id } = useParams<{ id: string }>();
  const [isLoading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState<ParticleArrangement>();
  const [arrangementAccessCodebookOptions, setArrangementAccessCodebookOptions] = useState<CodebookModel[]>([]);
  const [arrangementDrainageCodebookOptions, setArrangementDrainageCodebookOptions] = useState<CodebookModel[]>([]);
  const [arrangementElectricityCodebookOptions, setArrangementElectricityCodebookOptions] = useState<CodebookModel[]>([]);
  const dispatch = useDispatch();
  const {mutate: saveMutation, isPending: isSaving} = updateCaseParticleArrangementMutation(id, data => {
    setInitialData(data);
    showToast(toast.success, messages.DATA_SAVED);
  }, error => {
    if (Object.values(ERRORS).includes(error.data.message)) {
      showToast(toast.error, error.data.message);
    } else {
      showToast(toast.error, ERRORS.GENERIC_ERROR);
    }
  });

  useEffect(() => {
    setLoading(true);

    fetchCodebooks();

    fetchParticleArrangement(id).then(particleArrangement => {
      setInitialData(particleArrangement);
      setLoading(false);
    });
  }, [id]);

  const fetchCodebooks = () => {
    fetchArrangementAccessCodebook().then(data => setArrangementAccessCodebookOptions(data));
    fetchArrangementDrainageCodebook().then(data => setArrangementDrainageCodebookOptions(data));
    fetchArrangementElectricityCodebook().then(data => setArrangementElectricityCodebookOptions(data));
  };

  const FormikValueObserver = ({ onChange }) => {
    const { dirty } = useFormikContext();

    useEffect(() => onChange({ dirty }), [dirty, onChange]);

    return null;
  };

  const handleSubmit = (values, { setSubmitting }) => {
    saveMutation(values);
  };

  return (
    <>
      <Formik enableReinitialize={true} initialValues={initialData} onSubmit={handleSubmit}>
        {({ errors, isValid, dirty, submitForm, setFieldValue }) => (
          <Form>
            <FormikValueObserver
              onChange={dirty => {
                if (dirty.dirty) {
                  dispatch(setFormChanged(true));
                } else {
                  dispatch(initCaseFormChange());
                }
              }}
            />
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label labelText={'Pristup na prometnu površinu'} />
                  <Field
                    id="arrangementAccess"
                    name="arrangementAccess"
                    render={({ field }) => (
                      <FormikPredictiveInput options={arrangementAccessCodebookOptions} field={field} setFieldValue={setFieldValue} />
                    )}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label labelText={'Odvodnja otpadnih voda'} />
                  <Field
                    id="arrangementDrainage"
                    name="arrangementDrainage"
                    render={({ field }) => (
                      <FormikPredictiveInput options={arrangementDrainageCodebookOptions} field={field} setFieldValue={setFieldValue} />
                    )}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label labelText={'Priključenje na električnu mrežu'} />
                  <Field
                    id="arrangementElectricity"
                    name="arrangementElectricity"
                    render={({ field }) => (
                      <FormikPredictiveInput options={arrangementElectricityCodebookOptions} field={field} setFieldValue={setFieldValue} />
                    )}
                  />
                </FormGroup>
              </Col>
            </Row>

            <div className={'case-save-button'}>
              <Button
                color={'info'}
                label={'Spremi'}
                size={'lg'}
                isLoading={isSaving}
                onClick={submitForm}
                disabled={!dirty || !isValid}
              />
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ParticleArrangementForm;
